module.exports = __webpack_public_path__ + "static/assets/6afd82e5e0300c16d5937fc2df7a1e5a.png";